<template>
    <div class="myinfo-orders-box">
        <el-menu class="el-menu-demo" mode="horizontal" :default-active="defaultActive" @select="OnMenuSelect">
            <el-menu-item index="/orders/purchased">Purchased</el-menu-item>
            <el-menu-item index="/orders/sold">Has been sold</el-menu-item>
        </el-menu>
        
        <transition name="fadeInFn" mode="out-in">
            <router-view></router-view>
        </transition>
        
    </div>
</template>

<script>
import {format} from '@/utils/comm'
export default {
    data(){
        return{
            format:format,
            defaultActive:'',
        }
    },
    watch:{
        '$route.name':function(newVal,oldVal){
            this.initPage();
        }
    },
    created(){
        this.initPage();
    },
    methods:{
        initPage(){
            let currentPath = this.$route.path+'';
            this.defaultActive = currentPath.toLowerCase();
            // console.log(this.defaultActive);
        },
        OnMenuSelect(index){
            this.$router.push(index);
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.myinfo-orders-box{
    width: 100%;
    padding-bottom: vw(48);
    .el-menu-demo{
        
        padding: 0 vw(178);
    }
}
</style>